"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const react_1 = __importDefault(require("react"));
const StyledSvgIcon = (0, styles_1.styled)(SvgIcon_1.default)(() => ({
    boxSizing: 'content-box',
    padding: 3,
    fontSize: '1.125rem',
}));
function IconInner(props, ref) {
    const { icon, spin, sx = {}, ...res } = props;
    const { icon: [width, height, , , svgPathData], } = icon;
    return ((0, jsx_runtime_1.jsx)(StyledSvgIcon, { ref: ref, viewBox: `0 0 ${width} ${height}`, ...res, sx: {
            ...sx,
            ...(spin
                ? {
                    animation: 'spin 2s linear infinite',
                    '@keyframes spin': {
                        '0%': {
                            transform: 'rotate(0deg)',
                        },
                        '100%': {
                            transform: 'rotate(360deg)',
                        },
                    },
                }
                : {}),
        }, children: typeof svgPathData === 'string' ? ((0, jsx_runtime_1.jsx)("path", { d: svgPathData })) : (
        /**
         * A multi-path Font Awesome icon seems to imply a duotune icon. The 0th path seems to
         * be the faded element (referred to as the "secondary" path in the Font Awesome docs)
         * of a duotone icon. 40% is the default opacity.
         *
         * @see https://fontawesome.com/how-to-use/on-the-web/styling/duotone-icons#changing-opacity
         */
        svgPathData.map((d, i) => (0, jsx_runtime_1.jsx)("path", { style: { opacity: i === 0 ? 0.4 : 1 }, d: d }, i))) }));
}
exports.Icon = react_1.default.forwardRef(IconInner);
